// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1ijDn","label":"LabeledBox_label__1m5Dh"};